import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE = "https://acex.market";

interface Meta { title: string; description: string; noindex?: boolean }

const PUBLIC: Record<string, Meta> = {
  "/": { title: "ACEX — Crypto, P2P, Notes & Futures", description: "ACEX is a digital asset platform for crypto trading, P2P markets, Notes and Futures — built for speed, security and depth." },
  "/login": { title: "Sign In | ACEX", description: "Sign in to your ACEX account to trade crypto, use P2P markets, manage Notes and trade Futures securely." },
  "/signup": { title: "Create Your Account | ACEX", description: "Open a free ACEX account in minutes and start trading crypto, P2P, Notes and Futures on one secure platform." },
  "/notes": { title: "ACEX Notes — Structured Digital Asset Notes", description: "Explore ACEX Notes: structured digital asset products with clear terms, transparent payouts and secure custody." },
  "/ico": { title: "ACEX Launchpad — New Token Sales", description: "Discover upcoming and live token sales on the ACEX Launchpad and take part in new digital asset projects." },
  "/launchpad": { title: "ACEX Launchpad — New Token Sales", description: "Discover upcoming and live token sales on the ACEX Launchpad and take part in new digital asset projects." },
  "/cards": { title: "ACEX Cards — Spend Your Digital Assets", description: "Learn about ACEX cards and how to spend your digital asset balance wherever cards are accepted." },
  "/listing-apply": { title: "Apply for a Token Listing | ACEX", description: "Submit your project to be listed on ACEX. Tell us about your token and our listings team will review it." },
};

/** Sets a unique title, description, social preview and canonical link for each public page; private and utility pages are marked noindex. */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const meta = PUBLIC[path];
  const url = `${BASE}${path === "/" ? "/" : path}`;

  if (!meta) {
    return (
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
}
